// extracted by mini-css-extract-plugin
module.exports = {"notification":"malt-notification-index-notification-48aee21a","number":"malt-notification-index-number-dd9369cc"};